import { CompetitionsMatchCardSchema } from './CompetitionsMatchCard.styles';

export const competitionsMatchCardStyles: CompetitionsMatchCardSchema = {
  vsBoxWrapper: {
    position: 'relative',
    p: '1',
  },
  vsDivider: {
    borderStyle: 'dashed',
    borderTop: '1px dashed',
    borderTopColor: 'rgba(0, 0, 0, 0.25)',
    borderBottom: '1px dashed',
    borderBottomColor: 'rgba(255, 255, 255, 0.07)',
    ml: '20px',
    opacity: '1',
    w: '97%',
  },
  absoluteCenter: {
    px: '2',
    left: '2',
    ml: '1px',
    fontWeight: '',
    color: 'alpha.300',
    fontFamily: 'body',
    fontSize: 'xs',
    textTransform: 'uppercase',
  },
  matchCardOverride: {
    mb: '2',
    _last: {
      mb: '0',
    },
  },
  propositionButtonOverride: {
    w: '100%',
  },
  gridItem: {
    w: '100%',
  },
  flexWrapper: {
    alignItems: 'center',
  },
  flexText: {
    as: 'span',
    flex: '1',
    textAlign: 'left',
    fontWeight: 'bold',
    fontFamily: 'body',
    fontSize: 'xs',
    color: 'white',
    textTransform: 'uppercase',
  },
  gridWrapper: {
    gap: 2,
  },
  propositionButtonOverrideSecondary: {
    variant: 'odds',
    w: ['50px', '100px'],
    px: ['0', null, 'inherit'],
    lineHeight: 'normal',
  },
  gridItemTextNoProposition: {
    w: ['50px', '100px'],
    h: 'full',
    minH: '10',
    textAlign: 'center',
    color: 'whiteAlpha.500',
    fontFamily: 'body',
    fontWeight: 'black',
    fontSize: 'sm',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'md',
    border: '2px',
    borderColor: 'whiteAlpha.300',
    bg: 'transparent',
  },
  flexAwayTeam: {
    alignItems: 'center',
  },
  flexAwayTeamText: {
    flex: '1',
    textAlign: 'left',
    fontFamily: 'body',
    fontWeight: 'bold',
    fontSize: 'xs',
    color: 'white',
    textTransform: 'uppercase',
  },
};
